const ROUTES = ['/messaging', '/messaging/thread/:conversation'] as const

const Label = {
	Emoji: 'Open Emoji Keyboard'
}

export { Label, ROUTES }
